import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { UserAgents } from '../../constants/UserAgents'
import { RxJSState } from '../Types/Types'
import { $window } from '../AkixiWindow'

const headerSidebarCollapseSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    $window.AkixiUserAgentID === UserAgents.TEAMS
)

RxJS.headerSidebarCollapse = RxJS.headerSidebarCollapse ?? {
    subject: headerSidebarCollapseSubject,
    observable: headerSidebarCollapseSubject.asObservable(),
    announce: (open: boolean): void => headerSidebarCollapseSubject.next(open)
}

export const headerSidebarCollapse$: RxJSState<boolean> = RxJS.headerSidebarCollapse
